module.exports = __webpack_public_path__ + "img/time.c5edf2e8.svg";